import axios from 'axios'
import interceptors from './interceptors'
import { apiUrl } from '../../config'
import localforage from 'localforage'
import { isEmpty } from 'lodash'
import { userTokenStorageKey } from 'src/config'

// Add X-Page-URL interceptor to global axios (for any direct axios usage)
axios.interceptors.request.use(config => {
  if (typeof window !== 'undefined' && window.location) {
    const currentPath = window.location.pathname || '/';
    const fullUrl = window.location.origin + currentPath;
    if (config.headers && typeof config.headers.set === 'function') {
      config.headers.set('X-Page-URL', fullUrl);
    } else if (config.headers) {
      config.headers['X-Page-URL'] = fullUrl;
    } else {
      config.headers = { 'X-Page-URL': fullUrl };
    }
  }
  return config;
});

// allow use http client without Vue instance
export const http = axios.create({
  baseURL: apiUrl,
})

// Bind all functions and properties of axios to the http instance
for (const key in axios) {
  if (typeof axios[key] === 'function') {
    http[key] = axios[key].bind(http);
  } else {
    http[key] = axios[key];
  }
}

http.defaults.baseURL=apiUrl;
http.CancelToken = axios.CancelToken;
http.isCancel = axios.isCancel;

// Ensure default headers exist
if (!http.defaults.headers) {
  http.defaults.headers = {};
}
if (!http.defaults.headers.common) {
  http.defaults.headers.common = {};
}
http.defaults.headers.post = http.defaults.headers.post || {};
http.defaults.headers.post['Content-Type'] = 'application/json';

/**
* Helper method to set the header with the token
*/
export function setToken(token) {
  http.defaults.headers.common.Authorization = `Bearer ${token}`
}

// receive store and data by options
// https://vuejs.org/v2/guide/plugins.html
export default function install(Vue, { store, router }) {



  interceptors(http, store, router)
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/defineProperty
  Object.defineProperty(Vue.prototype, '$http', {

    get() {
      return http
    },
  })
}



// WEBPACK FOOTER //
// ./src/plugins/http/index.js